module.exports = {
      id: "closer-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#closer",
      toString: function () {
        return this.url;
      }
    }